import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const wsUrl = (code, participantId) => {
  const url = new URL(BACKEND_URL);
  const proto = url.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${url.host}/api/ws/${code}/${participantId}`;
};

export const api = axios.create({ baseURL: API });

export const createDraft = (payload) =>
  api.post("/drafts", payload).then((r) => r.data);

export const fetchDraft = (code) =>
  api.get(`/drafts/${code}`).then((r) => r.data);

export const joinDraft = (code, username) =>
  api.post(`/drafts/${code}/join`, { username }).then((r) => r.data);

export const startDraft = (code, participantId) =>
  api
    .post(`/drafts/${code}/start`, null, { params: { participant_id: participantId } })
    .then((r) => r.data);

export const promoteParticipant = (code, hostPid, targetPid, role) =>
  api
    .post(`/drafts/${code}/promote`, {
      host_participant_id: hostPid,
      target_participant_id: targetPid,
      role, // "drafter" | "spectator"
    })
    .then((r) => r.data);

export const addPlayer = (code, hostPid, name) =>
  api
    .post(`/drafts/${code}/players`, { host_participant_id: hostPid, name })
    .then((r) => r.data);

export const removePlayer = (code, hostPid, playerId) =>
  api
    .delete(`/drafts/${code}/players/${playerId}`, {
      params: { host_participant_id: hostPid },
    })
    .then((r) => r.data);

export const editDraft = (code, hostPid, changes) =>
  api
    .patch(`/drafts/${code}`, { host_participant_id: hostPid, ...changes })
    .then((r) => r.data);
